import { runDemo } from "../shared/demoRunner";
import { createChartingTestScene } from "./scene";

runDemo({ createScene: createChartingTestScene });
